export default {
  stats: {
    table: {
      rank: "Rang",
      name: "Name",
    },
    legend: {
      title: "Legende",
    },
    filters: {
      titles: {
        week: "Woche",
        round: "Runde",
        split: "Split",
      },
      options: {
        all: "Alle",
        qualifier: {
          cumulativeStats: "Gesamt",
          perGame: "Pro Spiel",
        },
      },
    },
  },
};
